import "./sprinkles.css.ts.vanilla.css-mistica.js";
var f = "_1y2v1nfe3 _1y2v1nfb5 _1y2v1nfbk _1y2v1nfbe _1y2v1nfe5", a = "_1y2v1nffz";
export { f as avatar, a as image };
